import { Injectable } from "@angular/core";
import { ApiAction } from "../../api-actions";
import { ApiPromiseStateService } from "../../api-promise-state.service";
import { ApiSessionService } from "../../api-session.service";
import { ApiStateStoreService } from "../../api-state-store.service";
import { extractData, OnsipApiResponse } from "../../apiResponse/response-body-new";
import { getApiActionName } from "../../onsip-api-action-new";
import { arrayToRecord } from "../../util/arrayToRecord";
import { ApiResourceService } from "../api-resource.service";
import { ApiPoolDid, PoolDid, apiPoolDidToPoolDid as clean } from "./pool-did";
export { PoolDid };

const debug = false;

@Injectable({ providedIn: "root" })
export class PoolDidService extends ApiResourceService<PoolDid> {
  constructor(
    session: ApiSessionService,
    store: ApiStateStoreService,
    promiseState: ApiPromiseStateService
  ) {
    super(session, store, promiseState, "PoolDid", "poolDidId");
    debug && this.state.subscribe(state => console.warn("PoolDidService", state));
  }

  /** frontend action only - removes poolDids from the store that have been purchased. This is not an api action. */
  removeFilledPoolDids(poolDidIds: Array<string>): void {
    const updateStateObject: Record<string, undefined> = {};
    poolDidIds.forEach(poolDidId => (updateStateObject[poolDidId] = undefined));
    this.store.mergeStateUpdate(
      this.resourceName,
      updateStateObject,
      ApiAction.DidRequestWithoutFill
    );
  }

  reducer(response: OnsipApiResponse): void {
    const action = getApiActionName(response);
    switch (action) {
      case ApiAction.DidRequestWithoutFill:
        this.store.mergeStateUpdate(
          this.resourceName,
          arrayToRecord(
            extractData<Array<ApiPoolDid>>(response, action, "PoolDid", "PoolDids").map(clean),
            this.indexKeyName
          ),
          action
        );
        break;
    }
  }
}
